import * as React from 'react';
export const TrackingContext = /*#__PURE__*/React.createContext({
  trackListingLinkClick: () => {},
  trackOffersModalOpen: () => {},
  trackModalOfferLinkClick: () => {},
  trackModalListingLinkClick: () => {}
});